import './App.css';
import Nav from './Pages/Components/Nav';
import Allroutes from './Pages/Components/Allroutes'


function App() {
  return (
    <div className="App">
      <Nav/>
      <Allroutes/>
    </div>
  );
}

export default App;
